import { selectStorageSpaceData } from '@/features/domain/order'
import { selectUserConfiguration } from '@/features/domain/user'

import { useSelector } from 'react-redux'

export function useControllerData() {
  const storageData = useSelector(selectStorageSpaceData)
  const { planType } = useSelector(selectUserConfiguration)

  return {
    percentage: storageData.percentage,
    totalOrders: storageData.totalOrders,
    currentOrders: storageData.currentOrders,
    wizardStep: 'warning' as const,
    isSimulation: planType === 'simulation',
  }
}
